import { useMemo, useCallback } from "react";
import * as R from "ramda";
import { useSessionStorage, decodeJWT } from "utils";

export const useSessionJWT = () => {
  const [data, setData] = useSessionStorage("tilia.ac.session");
  const sessionJWT = useMemo(() => (data ? JSON.parse(data) : null), [data]);
  const setSessionJWT = useCallback(
    (response, token) => {
      setData(
        JSON.stringify({
          token,
          status: response.status,
          jwt: R.path(["payload", "jwt"], response),
        })
      );
    },
    [setData]
  );
  const setSessionJWTFromObject = useCallback((sJWT) => {
    setData(JSON.stringify(sJWT));
  }, [setData]);
  const sessionData = decodeJWT(R.prop("jwt", sessionJWT) || "");
  return { sessionJWT, setSessionJWT, setSessionJWTFromObject, sessionData };
};
